import React, { useEffect, useState } from 'react'
import Page from '../../layouts/Page'
import { DESENDING_ORDER, LISTING_LIMIT, ORDER_DESCENDING } from '../../constants'
import useApi from "../../hooks/useApi";
import axios from 'axios';
import { customStringify } from '../../utils';
import { network_tl } from '../../translations';
import { FormattedMessage, useIntl } from 'react-intl';
import Loading from '../../components/Loading'
import RetryApi from '../../components/RetryApi';
import Pagination from '../../components/Pagination';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import Card from './Card';
import { IoNotificationsOutline } from 'react-icons/io5';
import { TfiReload } from 'react-icons/tfi';

const Notifications = () => {
    const { intl } = useIntl();
    const { Axios } = useApi();
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false);
    const [count, setCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [sort, setSort] = useState({ title: "created_on", order: DESENDING_ORDER });
    const [refresh, setRefresh] = useState(false);

    const agency_as_influencer = useSelector(state => state.influencer_profile.active);
    let offset = 0;

    const [filters, setFilters] = useState({
        search: "",
        city: "",
        category: "",
        followers: "",
        engagement_rate: "",
        cost: "",
        content: "",
        sort_order: ORDER_DESCENDING
    })

    const [appliedFilters, setAppliedFilters] = useState({
        search: "",
        city: "",
        category: "",
        followers: "",
        engagement_rate: "",
        cost: "",
        content: "",
        sort_order: ORDER_DESCENDING
    })

    const getData = async (curr) => {
        try {
            setLoading(true);
            setError(false);
            if (curr) {
                offset = 0;
            }
            else if (count) {
                offset = currentPage * LISTING_LIMIT - LISTING_LIMIT;
            } else {
                offset = 0;
            }
            const result = await Axios.get(`${agency_as_influencer ? `api/chat/get-notification` : `api/chat/get-notification`}?limit=${LISTING_LIMIT}&offset=${offset}`);
            setData(result.data.payload.messages);
            setLoading(false);
            setCount(result.data.count)
        } catch (e) {
            if (axios.isCancel(e)) {
            } else if (e.response) {
                setError(customStringify(e.response.data.description))
                setLoading(false)
            } else {
                setError(network_tl(intl))
                setLoading(false)
            }
        }
    }

    useEffect(() => {
        getData()
    }, [currentPage, sort, refresh])

    useEffect(() => {
        getData(1)
    }, [appliedFilters])

    const applyFilters = () => {
        const copy = _.cloneDeep(filters)
        setCurrentPage(1);
        setAppliedFilters(copy)
    }

    const resetFilters = () => {
        setCurrentPage(1)
        setFilters({
            search: "",
            city: "",
            category: "",
            followers: "",
            engagement_rate: "",
            cost: "",
            content: "",
            sort_order: ORDER_DESCENDING
        })
        setAppliedFilters({
            search: "",
            city: "",
            category: "",
            followers: "",
            engagement_rate: "",
            cost: "",
            content: "",
            sort_order: ORDER_DESCENDING
        })
    }

    const refreshListing = () => {
        setCurrentPage(1);
        setRefresh(prev => !prev);
    }

    return (
        <Page
            title={
                
                    <FormattedMessage id="notifications" defaultMessage={"Notifications"} />
                
            }
            breadcrumbs={[
                {
                    title: "Influencee",
                    link: "/"
                },
                {
                    title: "Notifications",
                    link: "/notifications"
                },
            ]}
        >
            <div className="container py-4 px-2">
                {/* Header with refresh button */}

                {/* Main content */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                    {loading && !error ? (
                        <div className="py-20">
                            <Loading />
                        </div>
                    ) : error && !loading ? (
                        <div className="py-20">
                            <RetryApi retry={getData} error={error} />
                        </div>
                    ) : (
                        <>
                            {data.length > 0 ? (
                                <div className="divide-y divide-gray-100">
                                    {data.map((item) => (
                                        <Card key={item.id} payload={item} type = {item.type} />
                                    ))}
                                </div>
                            ) : (
                                <div className="py-16 text-center">
                                    <div className="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                                        <IoNotificationsOutline className="text-3xl text-gray-400" />
                                    </div>
                                    <h3 className="text-lg font-medium text-gray-700 mb-2">
                                        <FormattedMessage 
                                            id="no_notifications" 
                                            defaultMessage="No notifications yet" 
                                        />
                                    </h3>
                                    <p className="text-gray-500 max-w-md mx-auto">
                                        <FormattedMessage 
                                            id="no_notifications_description" 
                                            defaultMessage="When you get new messages or updates, they'll appear here." 
                                        />
                                    </p>
                                </div>
                            )}
                        </>
                    )}

                    {/* Pagination */}
                    {count > LISTING_LIMIT && (
                        <div className="px-6 py-4 border-t flex w-full justify-end border-gray-100">
                            <Pagination
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                perPage={LISTING_LIMIT}
                                offset={offset}
                                total_pages={Math.ceil(count / LISTING_LIMIT)}
                                count={count}
                            />
                        </div>
                    )}
                </div>
            </div>
        </Page>
    )
}

export default Notifications